import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVisualBuilderBasePayload } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderDiscardModalViewed } from "@src/utils/mixpanel";

export interface TrackDiscardModalViewedPayload {
  source: "modification_edit" | "close_builder";
}

export const trackDiscardModalViewed = createAsyncThunk<
  void,
  TrackDiscardModalViewedPayload
>("experienceBuilder/tracking/discardModalViewed", (payload, { getState }) => {
  const basePayload = getVisualBuilderBasePayload(getState());
  if (basePayload) {
    const mods = experienceBuilderSlice.selectors.getMods(getState());
    const variationId =
      experienceBuilderSlice.selectors.getVariationId(getState());
    const variationMods = mods.filter((m) => m.variationId === variationId);
    const device = experienceBuilderSlice.selectors.getDevice(getState());

    const variations = selectedVariations(getState());
    mpVisualBuilderDiscardModalViewed({
      ...basePayload,
      test_group_count: variations.length,
      source: payload.source,
      mod_count: variationMods.length,
      builder_mode: device,
    });
  }
});
